// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__17zRN","title":"Images45_title__2thDd","images":"Images45_images__1N8fV"};